import React, { useContext } from "react";
import { AuthContext } from "../util/api";

export default function Map() {

   const { info } = useContext(AuthContext);
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "900px",
        margin: "40px auto",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0px 10px 25px rgba(0,0,0,0.25)",
        transform: "scale(1)",
        transition: "0.4s ease-in-out",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
       {/*  <iframe src="" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
      <iframe
        title=" "
        width="100%"
        height="500"
        style={{
          border: "0",
          filter: "brightness(1.1) contrast(1.1) saturate(1.3)",
        }}
        loading="lazy"
        allowFullScreen
        src={info.map_link}
      ></iframe>

    
    </div>
  );
}
